export default __webpack_public_path__ + "static/media/Ies_Lamp.3d0ef1cc.png";